import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../js/IncludeManager'
import { Alert } from "../../js/ComponentManager";

/* 개발담당:이재호
 * 화면기능:패스워드 체크 팝업
 * 세부설명:
*/

export class PwCheck extends Component {
    static displayName = PwCheck.name;

    constructor(props) {
        super(props);
        this.state = {
            isEyeOpen: false,
            isEyeText: "password",
            Login_Id: "",
            Password: "",
            Content: "비밀번호가 일치하지 않습니다.",
            isShowBtn: false
        };
        this.PwCheckRef = React.createRef();

        this.handleEye_Click = this.handleEye_Click.bind(this);
        this.handle_Click = this.handle_Click.bind(this);
        this.handle_Change = this.handle_Change.bind(this);
    }
    //초기화
    async componentDidMount() {
        let data = await Big3Common.Get("api/Common/UserInfomation");
        if (data.codeName !== Big3Common.ResultCode.NoSession) {
            let login_id = JSON.parse(data.multiDataTable)["userinfo"].Login_Id;
            this.setState({ Login_Id: login_id });
        }
    }
    handleEye_Click(event) {
        if (this.state.isEyeOpen === false) {
            this.setState({ isEyeOpen: true, isEyeText: "text" });
        }
        else {
            this.setState({ isEyeOpen: false, isEyeText: "password" });
        }
        event.preventDefault();
    }
    async handle_Click() {
        try {
            let data = await Big3Common.Post("api/MyPage/MyInfoMgr/PasswordValid", { password: this.state.Password });
            if (data.codeName === Big3Common.ResultCode.Success) {
                let Count = JSON.parse(data.objectData);
                if (Count > 0) {
                    Big3Common.ModalClose(bootstrap, 'PwCheck');
                    this.props.requestPayment();
                }
                else {
                    Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                }
            }
            else {
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
        }
        catch (e) {
            console.log("handle_Click: ", e);
        }

    }

    handle_Change(event) {
        let Password = event.target.value.trim();
        if (Password !== "") {
            this.setState({ isShowBtn: true, Password: Password });
        }
        else {
            this.setState({ isShowBtn: false, Password: Password });
        }

        event.preventDefault();
    }
    render() {
        return (
            <div className="modal fade show" id="PwCheck" aria-modal="true" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered ">
                    <div className="modal-content ordertype_modal">
                        <div className="modal-body text-center ">
                            <div className="desc ordertype_modal_in">
                                <div className="modal_title">비밀번호 확인</div>
                            </div>

                            <div className="password_check_modal">
                                <div className="my_info_txt">개인 정보를 안전하게 보호하기 위해<br></br> 비밀번호를 다시 한 번 입력해주세요.</div>
                                <div className="input_line">
                                    <label>아이디</label>
                                    <div>{this.state.Login_Id}</div>
                                </div>
                                <div className="input_line my_info_input_line">
                                    <label>비밀번호</label>
                                    <input type={this.state.isEyeText}
                                        className="form-control"
                                        maxLength="20"
                                        placeholder="영문 대/소문자,특수기호 포함 8자리"
                                        autoComplete="off"
                                        onChange={this.handle_Change}
                                    />
                                    <div className={this.state.isEyeOpen === true ? "eye_close" : "eye_open"} onClick={this.handleEye_Click}></div>
                                </div>
                            </div>

                            {
                                this.state.isShowBtn === false ?
                                    <button type="button" className="btn_v btn_inactive">확인</button> :
                                    <button type="button" className="btn_v btn_v1" onClick={this.handle_Click}>확인</button>
                            }

                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                </div>
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="비밀번호안내"
                />
            </div>
        );
    }
}
